import Section from "./Section";
import React from "react";

export default function Wochenplan() {
    return <>
        <Section id={'wochenplan'} className={'mx-4'}>
            <h2 className={'text-3xl underline mb-6 mt-12 font-semibold'}>Wochenplan:</h2>
            <a
                href={'https://handouts.buntergrundkurs.de/2026/plan.html'}
                target={'_blank'}
                type="button"
                className="rounded-md bg-pink px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
            >
                Zum Wochenplan
            </a>
        </Section>
        <Section id={'bilder'}  className={'mx-4'}>
            <h2 className={'text-3xl underline mb-6 mt-12 font-semibold'}>Bilder:</h2>
            <a
                href={'https://cloud.buntergrundkurs.de/s/2ofXrRKxw2EAWPy'}
                target={'_blank'}
                type="button"
                className="rounded-md bg-pink px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
            >
                Zur Bildercloud
            </a>
        </Section>
        <Section id={'Handouts'}  className={'mx-4'}>
            <h2 className={'text-3xl underline mb-6 mt-12 font-semibold'}>Handouts & Unterlagen:</h2>
            <a
                href={'https://cloud.buntergrundkurs.de/s/w9bN0rZJZeOgNBs'}
                target={'_blank'}
                type="button"
                className="rounded-md bg-pink px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
            >
                Handouts & Unterlagen
            </a>
        </Section>
    </>
}